import React from "react";
import { Box, Typography } from "@mui/material";
import type { BarChartConfig } from "@store/slices/chart-config-slice";
import LoadingSpinner from "@components/common/LoadingSpinner";
import EmptyChartState from "@components/common/EmptyChartState";
import StackedBarChart from "../../StackedBarChart";

interface StackedBarPreviewPanelProps {
  currentConfig: BarChartConfig;
  datasetId?: string | null;
  isRefetchingData: boolean;
  isAvailableData: boolean;
}

const StackedBarPreviewPanel: React.FC<StackedBarPreviewPanelProps> = ({
  currentConfig,
  datasetId,
  isRefetchingData,
  isAvailableData,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        p: 3,
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Preview
      </Typography>
      <Box
        sx={{
          flex: 1,
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          minHeight: 400,
          display: "flex",
          ...(isRefetchingData || isAvailableData
            ? { alignItems: "center", justifyContent: "center" }
            : {}),
          p: 2,
        }}
      >
        {isRefetchingData ? (
          <LoadingSpinner message="Loading data..." />
        ) : isAvailableData ? (
          <EmptyChartState message="This question has no response data available for visualization" />
        ) : (
          // StackedBarChart renders its own footer (via StackedBarFooter) including
          // weight, time period, and rolling average — no separate footer needed here.
          <StackedBarChart config={currentConfig} datasetId={datasetId} />
        )}
      </Box>
    </Box>
  );
};

export default StackedBarPreviewPanel;
